import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../../../../dist/asyncToGenerator-c002e3ca.esm.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.regexp.to-string.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/web.url.js';
import 'core-js/modules/web.url-search-params.js';
import 'core-js/modules/es.promise.js';
import fetch from 'cross-fetch';
import { i as isClient } from '../../../../dist/utils-1cd6e65a.esm.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.string.includes.js';

/**
 * Checks if WebRTC WHEP can play in the browser.
 */
var isWebRTCSupported = function isWebRTCSupported() {
  if (!isClient()) {
    return false;
  }
  var hasRTCPeerConnection = !!(window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection);
  var hasGetUserMedia = !!(navigator.getUserMedia || navigator.mediaDevices.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia);
  var hasRTCDataChannel = !!(window.RTCDataChannel || window.webkitRTCDataChannel || window.mozRTCDataChannel);
  return hasRTCPeerConnection && hasGetUserMedia && hasRTCDataChannel;
};
var peerConnection = null;
var stream = null;
function createPeerConnection(host) {
  var RTCPeerConnectionConstructor = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;
  var iceServers = host ? [{
    urls: "stun:".concat(host)
  }, {
    urls: "turn:".concat(host),
    username: 'livepeer',
    credential: 'livepeer'
  }] : [];
  if (RTCPeerConnectionConstructor) {
    return new RTCPeerConnectionConstructor({
      iceServers: iceServers
    });
  }
  return null;
}
var DEFAULT_TIMEOUT = 10000;

/**
 * Client that uses WHEP to playback video over WebRTC.
 *
 * https://www.ietf.org/id/draft-murillo-whep-00.html
 */
var createNewWHEP = function createNewWHEP(source, element, callbacks, config) {
  var destroyed = false;
  var abortController = new AbortController();
  stream = new MediaStream();
  getRedirectUrl(source, abortController, config === null || config === void 0 ? void 0 : config.sdpTimeout).then(function (redirectUrl) {
    if (destroyed || !redirectUrl) {
      return;
    }
    var redirectUrlString = redirectUrl.toString();

    /**
     * Create a new WebRTC connection, using public STUN servers with ICE,
     * allowing the client to discover its own IP address.
     * https://developer.mozilla.org/en-US/docs/Web/API/WebRTC_API/Protocols#ice
     */
    peerConnection = createPeerConnection(redirectUrl.host);
    if (peerConnection) {
      /** https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/addTransceiver */
      peerConnection.addTransceiver('video', {
        direction: 'recvonly'
      });
      peerConnection.addTransceiver('audio', {
        direction: 'recvonly'
      });

      /**
       * When new tracks are received in the connection, store local references,
       * so that they can be added to a MediaStream, and to the <video> element.
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/track_event
       */
      peerConnection.ontrack = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
          var track, currentTracks, streamAlreadyHasVideoTrack, streamAlreadyHasAudioTrack, _callbacks$onError;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  if (!stream) {
                    _context.next = 18;
                    break;
                  }
                  track = event.track;
                  currentTracks = stream.getTracks();
                  streamAlreadyHasVideoTrack = currentTracks.some(function (track) {
                    return track.kind === 'video';
                  });
                  streamAlreadyHasAudioTrack = currentTracks.some(function (track) {
                    return track.kind === 'audio';
                  });
                  _context.t0 = track.kind;
                  _context.next = _context.t0 === 'video' ? 9 : _context.t0 === 'audio' ? 13 : 17;
                  break;
                case 9:
                  if (!streamAlreadyHasVideoTrack) {
                    _context.next = 11;
                    break;
                  }
                  return _context.abrupt("break", 18);
                case 11:
                  stream.addTrack(track);
                  return _context.abrupt("break", 18);
                case 13:
                  if (!streamAlreadyHasAudioTrack) {
                    _context.next = 15;
                    break;
                  }
                  return _context.abrupt("break", 18);
                case 15:
                  stream.addTrack(track);
                  return _context.abrupt("break", 18);
                case 17:
                  console.log('got unknown track ' + track);
                case 18:
                  _context.next = 23;
                  break;
                case 20:
                  _context.prev = 20;
                  _context.t1 = _context["catch"](0);
                  callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$onError = callbacks.onError) === null || _callbacks$onError === void 0 ? void 0 : _callbacks$onError.call(callbacks, _context.t1);
                case 23:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 20]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
      peerConnection.addEventListener('connectionstatechange', /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ev) {
          var _peerConnection, _peerConnection2, _callbacks$onConnecte, _callbacks$onError2;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  if (!(((_peerConnection = peerConnection) === null || _peerConnection === void 0 ? void 0 : _peerConnection.connectionState) === 'failed')) {
                    _context2.next = 3;
                    break;
                  }
                  throw new Error('Failed to connect to peer.');
                case 3:
                  if (((_peerConnection2 = peerConnection) === null || _peerConnection2 === void 0 ? void 0 : _peerConnection2.connectionState) === 'connected' && !element.srcObject) {
                    element.srcObject = stream;
                    callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$onConnecte = callbacks.onConnected) === null || _callbacks$onConnecte === void 0 ? void 0 : _callbacks$onConnecte.call(callbacks);
                  }
                  _context2.next = 9;
                  break;
                case 6:
                  _context2.prev = 6;
                  _context2.t0 = _context2["catch"](0);
                  callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$onError2 = callbacks.onError) === null || _callbacks$onError2 === void 0 ? void 0 : _callbacks$onError2.call(callbacks, _context2.t0);
                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 6]]);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
      peerConnection.addEventListener('negotiationneeded', /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ev) {
          var ofr, _callbacks$onError3;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  _context3.next = 3;
                  return constructClientOffer(peerConnection, redirectUrlString);
                case 3:
                  ofr = _context3.sent;
                  _context3.next = 6;
                  return negotiateConnectionWithClientOffer(peerConnection, redirectUrlString, ofr, config === null || config === void 0 ? void 0 : config.sdpTimeout);
                case 6:
                  _context3.next = 11;
                  break;
                case 8:
                  _context3.prev = 8;
                  _context3.t0 = _context3["catch"](0);
                  callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$onError3 = callbacks.onError) === null || _callbacks$onError3 === void 0 ? void 0 : _callbacks$onError3.call(callbacks, _context3.t0);
                case 11:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[0, 8]]);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }).catch(function (e) {
    var _callbacks$onError4;
    return callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$onError4 = callbacks.onError) === null || _callbacks$onError4 === void 0 ? void 0 : _callbacks$onError4.call(callbacks, e);
  });
  return {
    destroy: function destroy() {
      var _abortController$abor, _peerConnection3, _peerConnection3$clos;
      destroyed = true;
      abortController === null || abortController === void 0 ? void 0 : (_abortController$abor = abortController.abort) === null || _abortController$abor === void 0 ? void 0 : _abortController$abor.call(abortController);

      // Remove the WebRTC source
      if (element) {
        element.srcObject = null;
      }
      (_peerConnection3 = peerConnection) === null || _peerConnection3 === void 0 ? void 0 : (_peerConnection3$clos = _peerConnection3.close) === null || _peerConnection3$clos === void 0 ? void 0 : _peerConnection3$clos.call(_peerConnection3);
    }
  };
};

/**
 * Performs the actual SDP exchange.
 *
 * 1. Sends the SDP offer to the server,
 * 2. Awaits the server's offer.
 *
 * SDP describes what kind of media we can send and how the server and client communicate.
 *
 * https://developer.mozilla.org/en-US/docs/Glossary/SDP
 * https://www.ietf.org/archive/id/draft-ietf-wish-whip-01.html#name-protocol-operation
 */
function negotiateConnectionWithClientOffer(_x4, _x5, _x6, _x7) {
  return _negotiateConnectionWithClientOffer.apply(this, arguments);
}
/**
 * Constructs the client's SDP offer
 *
 * SDP describes what kind of media we can send and how the server and client communicate.
 *
 * https://developer.mozilla.org/en-US/docs/Glossary/SDP
 * https://www.ietf.org/archive/id/draft-ietf-wish-whip-01.html#name-protocol-operation
 */
function _negotiateConnectionWithClientOffer() {
  _negotiateConnectionWithClientOffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(peerConnection, endpoint, ofr, timeout) {
    var response, answerSDP, errorMessage;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(peerConnection && endpoint && ofr)) {
              _context4.next = 19;
              break;
            }
            _context4.next = 3;
            return postSDPOffer(endpoint, ofr.sdp, timeout);
          case 3:
            response = _context4.sent;
            if (!response.ok) {
              _context4.next = 13;
              break;
            }
            _context4.next = 7;
            return response.text();
          case 7:
            answerSDP = _context4.sent;
            _context4.next = 10;
            return peerConnection.setRemoteDescription(new RTCSessionDescription({
              type: 'answer',
              sdp: answerSDP
            }));
          case 10:
            return _context4.abrupt("return", response.headers.get('Location'));
          case 13:
            _context4.next = 15;
            return response.text();
          case 15:
            errorMessage = _context4.sent;
            throw new Error(errorMessage);
          case 17:
            _context4.next = 20;
            break;
          case 19:
            throw new Error('Peer connection not defined.');
          case 20:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _negotiateConnectionWithClientOffer.apply(this, arguments);
}
function constructClientOffer(_x8, _x9) {
  return _constructClientOffer.apply(this, arguments);
}
function _constructClientOffer() {
  _constructClientOffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(peerConnection, endpoint) {
    var offer, ofr;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(peerConnection && endpoint)) {
              _context5.next = 12;
              break;
            }
            _context5.next = 3;
            return peerConnection.createOffer();
          case 3:
            offer = _context5.sent;
            _context5.next = 6;
            return peerConnection.setLocalDescription(offer);
          case 6:
            _context5.next = 8;
            return waitToCompleteICEGathering(peerConnection);
          case 8:
            ofr = _context5.sent;
            if (ofr) {
              _context5.next = 11;
              break;
            }
            throw Error('failed to gather ICE candidates for offer');
          case 11:
            return _context5.abrupt("return", ofr);
          case 12:
            return _context5.abrupt("return", null);
          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _constructClientOffer.apply(this, arguments);
}
function postSDPOffer(_x10, _x11, _x12) {
  return _postSDPOffer.apply(this, arguments);
}
function _postSDPOffer() {
  _postSDPOffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(endpoint, data, timeout) {
    var controller, id, response;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            controller = new AbortController();
            id = setTimeout(function () {
              return controller.abort();
            }, timeout !== null && timeout !== void 0 ? timeout : DEFAULT_TIMEOUT);
            _context6.next = 4;
            return fetch(endpoint, {
              method: 'POST',
              mode: 'cors',
              headers: {
                'content-type': 'application/sdp'
              },
              body: data,
              signal: controller.signal
            });
          case 4:
            response = _context6.sent;
            clearTimeout(id);
            return _context6.abrupt("return", response);
          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _postSDPOffer.apply(this, arguments);
}
function getRedirectUrl(_x13, _x14, _x15) {
  return _getRedirectUrl.apply(this, arguments);
}
/**
 * Receives an RTCPeerConnection and waits until
 * the connection is initialized or a timeout passes.
 *
 * https://www.ietf.org/archive/id/draft-ietf-wish-whip-01.html#section-4.1
 * https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/iceGatheringState
 * https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/icegatheringstatechange_event
 */
function _getRedirectUrl() {
  _getRedirectUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(endpoint, abortController, timeout) {
    var id, response, parsedUrl;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            id = setTimeout(function () {
              return abortController.abort();
            }, timeout !== null && timeout !== void 0 ? timeout : DEFAULT_TIMEOUT);
            _context7.prev = 1;
            _context7.next = 4;
            return fetch(endpoint, {
              method: 'HEAD',
              signal: abortController.signal,
              redirect: 'manual'
            });
          case 4:
            response = _context7.sent;
            clearTimeout(id);
            parsedUrl = new URL(response.url);
            return _context7.abrupt("return", parsedUrl);
          case 10:
            _context7.prev = 10;
            _context7.t0 = _context7["catch"](1);
            return _context7.abrupt("return", null);
          case 13:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[1, 10]]);
  }));
  return _getRedirectUrl.apply(this, arguments);
}
function waitToCompleteICEGathering(_x16) {
  return _waitToCompleteICEGathering.apply(this, arguments);
}
function _waitToCompleteICEGathering() {
  _waitToCompleteICEGathering = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(peerConnection) {
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", new Promise(function (resolve) {
              /** Wait at most five seconds for ICE gathering. */
              setTimeout(function () {
                resolve(peerConnection.localDescription);
              }, 5000);
              peerConnection.onicegatheringstatechange = function (_ev) {
                if (peerConnection.iceGatheringState === 'complete') {
                  resolve(peerConnection.localDescription);
                }
              };
            }));
          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _waitToCompleteICEGathering.apply(this, arguments);
}

export { createNewWHEP, isWebRTCSupported };
